import { render } from "./DialogLoading.vue?vue&type=template&id=610e1b05&ts=true"
import script from "./DialogLoading.vue?vue&type=script&lang=ts"
export * from "./DialogLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__